export default __webpack_public_path__ + "static/media/marker-gray-blue-sky.96782cbb.png";